import { DateUtils, HotelRoomUtils } from '../../utils';
import { HotelStandalonePaxRestrictionPropsDefault } from '../../models';
import { HotelStandaloneRoomParams } from './composeHotelStandaloneRoomParams';
import { CampaignParams } from './composeCampaignParams';
import { SearchByPropertyParams } from './composeSearchByPropertyParams';
import { AstIdParam } from './composeAstIdParam';

export const composeHotelStandaloneParams = ({
    segments = [],
    rooms = [],
    astId,
    searchId,
    buyPath = null,
    searchExtensionParam
}) => {
    const { geoNodeId, type, id, regionType = null } = segments[0].destination;
    const limitRooms = HotelRoomUtils.getRoomsAvailableByRestrictions(
        rooms,
        HotelStandalonePaxRestrictionPropsDefault,
    );

    const searchParams = `checkIn=${DateUtils.toString(segments[0].date)}`
        .concat(`;checkOut=${DateUtils.toString(segments[1].date)}`)
        .concat(geoNodeId ? `;geoNodeId=${geoNodeId}` : '')
        .concat(`${HotelStandaloneRoomParams.compose(limitRooms)}`)
        .concat(`${CampaignParams.compose()}`)
        .concat(searchId ? `;searchId=${searchId}` : '')
        .concat(buyPath ? `;buyPath=${buyPath}` : '')
        .concat(regionType ? `;regionType=${regionType}` : '')
        .concat(';internalSearch=true')
        .concat(searchExtensionParam);

    const accommodationParam = SearchByPropertyParams.compose(type, id);
    const astIdParam = AstIdParam.compose({ astId });
    const queryParams = [accommodationParam, astIdParam].filter(Boolean).join('&');

    return queryParams.length === 0
        ? `${searchParams}`
        : `${searchParams}?${queryParams}`;
};
